var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShuffleAngular = function SvgIconShuffleAngular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M3 6.75h4.866a.73.73 0 0 1 .609.319l7.05 9.862a.73.73 0 0 0 .61.319h5.615m0 0L19.5 15m2.25 2.25L19.5 19.5m0-15 2.25 2.25m0 0L19.5 9m2.25-2.25h-5.616a.73.73 0 0 0-.609.319l-1.219 1.706M3 17.25h4.866a.73.73 0 0 0 .609-.319l1.219-1.706"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.705 3.705c.439-.44 1.151-.44 1.59 0l2.25 2.25c.44.439.44 1.151 0 1.59l-2.25 2.25a1.125 1.125 0 0 1-1.59-1.59l.329-.33h-2.702l-1.11 1.554A1.125 1.125 0 1 1 13.39 8.12l1.213-1.699a1.86 1.86 0 0 1 1.534-.797h2.896l-.33-.33a1.125 1.125 0 0 1 0-1.59M7.667 7.874H3a1.125 1.125 0 0 1 0-2.25h4.862a1.86 1.86 0 0 1 1.534.797l6.935 9.703h2.703l-.33-.33a1.125 1.125 0 0 1 1.592-1.59l2.25 2.25c.439.439.439 1.151 0 1.59l-2.25 2.25a1.125 1.125 0 0 1-1.591-1.59l.329-.33h-2.896a1.86 1.86 0 0 1-1.534-.797zm2.68 6.435c.505.36.622 1.063.261 1.569l-1.213 1.699a1.86 1.86 0 0 1-1.534.797H3a1.125 1.125 0 0 1 0-2.25h4.668l1.11-1.554a1.125 1.125 0 0 1 1.57-.261",
    clipRule: "evenodd"
  })));
};
export default SvgIconShuffleAngular;